<template>
  <div>
    <AlertDismiss ref="alertDismiss" class="mt-2 ms-2"></AlertDismiss>
    <div class="card p-2 ps-4 gap-0 fw-medium container-card">
      <template v-if="fetching">
        <div class="d-flex align-items-center">
          <b-spinner small variant="light" class="m-2"></b-spinner>
          <p class="text-white-50 m-0">Cargando información de usuario...</p>
        </div>
      </template>
      <template v-else>
        <p class="text-card m-0">
          Bienvenido {{ user.name }} {{ user.lastName }}
        </p>
        <p class="text-card m-0">
          {{ company.legalName }}
        </p>
        <p class="text-card m-0">
          {{ company.direction }}, {{ company.city }}
        </p>
        <p class="text-card m-0">
          RUT: {{ formattedRut }}
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import AlertDismiss from '../shared/Alert-dismiss.vue';
import { formatRut } from '@/plugins/complianceScripts';
import config from '@/plugins/config';

export default {
  name: 'UserInformation',

  data() {
    return {
      user: {
        name: '',
        lastName: ''
      },
      company: {
        legalName: '',
        address: '',
        rut: ''
      },
      fetching: false
    }
  },
  components: {
    AlertDismiss
  },
  computed: {
    ...mapGetters(["getSession"]),
    formattedRut() {
      return formatRut(this.company.rut);
    },
    menuBgColor() {
      return config.theme.menuBackgroundColor;
    }
  },

  methods: {
    ...mapActions(["getUserById", "getCompany"] ),
    
    async fetchUser() {
      const userResponse = await this.getUserById({ id: this.getSession.UserId });
      if (userResponse.isError) {
        this.$refs.alertDismiss.showAlert(userResponse.message);
        this.fetching = false;
        return
      }
      this.user.name = userResponse.data.name
      this.user.lastName = userResponse.data.lastName
    },
    async fetchCompany() {
      const companyResponse = await this.getCompany();
      if (companyResponse.isError) {
        this.$refs.alertDismiss.showAlert(companyResponse.message);
        this.fetching = false;
        return
      }
      this.company.legalName = companyResponse.data.legalName
      this.company.direction = companyResponse.data.direction
      this.company.rut = companyResponse.data.rut
      this.company.city = companyResponse.data.city      
    }
  },

  async mounted() {
    this.fetching = true;

    await this.fetchUser();
    await this.fetchCompany();

    this.fetching = false;
  }

}
</script>

<style scoped>
.card {
  background-color: v-bind(menuBgColor);
}

.text-card{
  color: #ffffff;
  font-size: 14px
}

.container-card {
  min-height: 100px;
}
</style>
